<template>
	<div class="messages">
		<div class="row">
			<div class="col-6 mb-4">
				<h1>{{ $t("clinical-cases") }}</h1>
			</div>
			<div class="col-6 d-lg-none mb-4">
			</div>
			<div class="d-none d-lg-inline col-6">
				<input
					type="search"
					:placeholder="$t('search-clinical-cases-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-clinical-cases-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
		</div>

		<InfiniteScroll
			type="ClinicalCase"
			:dataUrl="`${$settings.APIBaseURL}/clinicalcases/list`"
			dataProperty="results"
			class="inspector-list full-width"
			itemClass="inspector-list-item"
			@selectItem="selectClinicalCase"
			ref="clinicalcases"
			:lookaheadPx="50"
			:noResultsText="$t('no-clinical-cases-found')"
		/>

		<div class="inspector-list-detail active" v-if="selectedClinicalcase">

			<a class="btn btn-light btn-xs float-right"
				style="margin: -5px 0 0 0"
				v-on:click="closeView()"><b-icon icon="x" width="1em" height="1em"></b-icon>
			</a>

			<h2>{{ selectedClinicalcase.patientref }}</h2>
			<p>{{ $t('created-colon') }} <strong>{{ this.$datetime.getLocaleStringFromTimeStamp(selectedClinicalcase.created) }}</strong></p>			
			<InfiniteScroll
			scrollElementId="main"
			type="TreatmentSession"
			:dataUrl="`${$settings.APIBaseURL}/treatmentsessions/list`"
			dataProperty="treatmentsessions"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectTreatmentSession"
			ref="treatmentsessions"
			:noResultsText="$t('no-treatment-sessions-found')"
			/>
		</div>

	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			selectedClinicalcase: null,
			searchTerm: null,
			searchTimer: null
		};
	},
	mounted() {
		this.getClinicalCases();
	},
	methods: {
		getTreatmentSessions() {
			const body = {
				clinicalcase_id: this.selectedClinicalcase.id,
				studentId: this.$UserSession.getValue.call(this, "id")
			};
			this.$refs.treatmentsessions.getData('replace', body);
		},		
		selectTreatmentSession(treatmentsession) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/clinical/treatmentsession/${treatmentsession.id}`);
		},
		selectClinicalCase(clinicalcase) {
			this.selectedClinicalcase = clinicalcase;
			this.$nextTick(function() {
				this.getTreatmentSessions();
			});
		},
		closeView() {
			this.selectedClinicalcase = null;
		},
		getClinicalCases() {
			const body = {};
			if (this.searchTerm) {
				body.q = this.searchTerm;
			}
			this.$refs.clinicalcases.getData("replace", body);
		},
		searchTermChange() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.getClinicalCases();
			}, 500);
		}
	}
};
</script>
